export const GET_SUPPLIES = 'GET_SUPPLIES';
export const GET_SUPPLIES_PENDING = 'GET_SUPPLIES_PENDING';
export const GET_SUPPLIES_FULFILLED = 'GET_SUPPLIES_FULFILLED';
export const GET_SUPPLIES_REJECTED = 'GET_SUPPLIES_REJECTED';
export const SUPPLIES_RESET_STATE = 'SUPPLIES_RESET_STATE';
export const SUPPLIES_ADD_EXPANDED = 'SUPPLIES_ADD_EXPANDED';
export const SUPPLIES_REMOVE_EXPANDED = 'SUPPLIES_REMOVE_EXPANDED';
export const SUPPLIES_PAGE_CHANGE = 'SUPPLIES_PAGE_CHANGE';
export const SUPPLIES_SET_PAGE_ON_FILTER = 'SUPPLIES_SET_PAGE_ON_FILTER';
